import { gql } from '@apollo/client';

export const INTERMEDIARY_LIST = gql`
  query IntermediaryList {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const SEARCH_CUSTOMER_BY_NUMBER = gql`
  query searchCustomerByNumber($input: ViewCustInput) {
    customer(input: $input) {
      cust_number
      cust_type {
        code
        value
      }
      is_blackListed
      cust_ref_number
      bank_detail {
        name
        branch_name
        ifsc_code
        acc_number
        acc_holder
        micr_code
      }
      indv_detail {
        title {
          value
          code
        }
        employeeNumber
        first_name
        middle_name
        surname
        full_name
        gender {
          value
          code
        }
        date_of_birth
        id_proof_type {
          value
          code
        }
        id_proof_number
        pan_card_number
        marital_status {
          value
          code
        }
        occupation {
          value
          code
        }
        nationality {
          value
          code
        }
      }
      org_detail {
        org_name
        org_type {
          value
          code
        }
        contact_name
        contact_email
        tan_number
        pan_card_number
        reg_number
        gst_number
      }
      contact {
        email
        mobile
        telephone
        fax_number
        alt_telephone
        alt_mobile
      }
      permanent_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      comm_equal_perm
      communication_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      alert_action {
        alertCount
        alertContext {
          alert
          action
        }
      }
    }
  }
`;

export const GET_DEFAULT_CLAUSES = gql`
  query getDefaultClauses(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultClauses(input: $input) {
      clauseCode
      clauseDescription
      clauseNumber
      default
      txtClauseType
      description
    }
  }
`;

export const GET_DEFAULT_CONDITIONS = gql`
  query getDefaultConditions(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultConditions(input: $input) {
      conditionCode
      conditionShortDescription
      txtConditionNumber
      txtDefault
      txtConditionType
      description
    }
  }
`;

export const GET_DEFAULT_EXCLUSIONS = gql`
  query getDefaultExclusions(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultExclusions(input: $input) {
      exclusionCode
      exclusionShortDescription
      txtExclusionNumber
      txtDefault
      txtExclusionType
      description
    }
  }
`;

export const GET_DEFAULT_WARRANTIES = gql`
  query getDefaultWarranties(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultWarranties(input: $input) {
      warrantyCode
      warrantyShortDescription
      txtWarrantyNumber
      txtDefault
      txtWarrantyType
      description
    }
  }
`;

export const VIEW_POLICY_FIRE = gql`
query viewPolicyFire( $input: viewProposalInput ){
  viewPolicyFire(input: $input) {
    customerID
    proposalNumber
    proposalStatus
    policyNumber
    quoteNumber
    lob {
      lobCode
      lobName
    }
    product {
      productCode
      productName
    }
    businessOfInsured
    prevClaimExpDtls {
      anyPrevClaimsExp
      prevClaimExpDesc
    }
    isKutchaConstruct
    policyType
    tenure {
      code
      value
    }
    policyStartDate
    policyExpiryDate
    riskLocations {
      riskLocationID
      occupancyCodeValue {
        code
        value
        occupancySection
        occupancyRate
        riskCode
        rateCode
        riskGrade
        riskGradeDefinition
        riskPreference
        gicClass
        stfiRate
        rsmdRate
      }
      riskLocAddress {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
        location
        zone
        eqZone
        locationCode
        isSamePremises
        allIndiaBasisDesc
      }
      buildingSI
      plantMachinerySI
      furnitureFixtureSI
      rawMaterialSI
      otherContentsSI
      stockSI
      stocksInProcessSI
      stockOnFloaterBasis
      floaterLocations {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
        location
        zone
        eqZone
        locationCode
        isSamePremises
        allIndiaBasisDesc
      }
      maxStockSIAtOneLoc
      locationSI
      fireExtinguishApplisDtls {
        applianceCode
        applianceValue
        isSelected
      }
      constructionClass
      waterbodyDistance
      securityProvisions
      loadingPct
      discountPct
      prevClaimExpDesc
      premium {
        locationNetPremium
        locationGST
        locationTotalPremium
        stampDuty
        warningMsg
      }
    }
    intermediaryDetails {
      code
      location
      fieldUserCode
      fieldUserName
    }
    clauses {
      default
      userDefined
    }
    warranties {
      default
      userDefined
    }
    conditions {
      default
      userDefined
    }
    exclusions {
      default
      userDefined
    }
    finalisedPremium {
      locNetPremium
      locGST
      locTotalPremium
      stampDuty
    }
    financierDtls {
      financerName
      financerAddress
      financerAgreementType
      loanAccountNumber
      fileNumber
    }
    uploadedDocuments {
      documentType {
        code
        value
      }
      documentName
      documentSize
      base64EncodedDoc
    }
    underwriterComment
    userID
  }
}
`;

export const DOWNLOAD_FIRE_POLICY_PDF = gql`
  mutation downloadPolicyPDFFire($input: FireProposalInput ) {
    downloadPolicyPDFFire(input: $input) {
      base64Pdf
    }
  }
`;

export const SEND_POLICY_EMAIL_FIRE = gql`
  mutation sendPolicyEmailFire(
    $input: FireProposalInput
    $email: StrictEmail
    $ccEmailIds: [StrictEmail]
  ) {
    sendPolicyEmailFire(
      input: $input
      email: $email
      ccEmailIds: $ccEmailIds
    ) {
      message
      quoteNumber
    }
  }
`;

export const SEND_POLICY_SMS_FIRE = gql`
  mutation sendPolicySMSFire(
    $input: FireProposalInput
    $mobile: StrictNumber
    $alternateMobileNos: [StrictNumber]
  ) {
    sendPolicySMSFire(
      input: $input
      mobile: $mobile
      alternateMobileNos: $alternateMobileNos
    ) {
      message
      quoteNumber
    }
  }
`;
export const VIEW_PROPOSAL_FIRESF = gql`
  query viewProposalSF($input: viewProposalInput) {
    viewProposalSF(input: $input) {
      customerID
      proposalNumber
      proposalStatus
      policyNumber
      quoteNumber
      TypeofBusiness
      IsApplicableForPayment
      Proposal_Payment_Type
      startDate
      endDate
      Sum_Insured
      intermediaryDetails {
          code
          location
          fieldUserCode
          fieldUserName
      }
        finalisedPremium {
          locNetPremium
          locGST
          locTotalPremium
          stampDuty
      }
      ThirdGrid_Details
        {
            Occupancy_Name  
            Cost_Of_Construction
            Carpet_Area
            Building_Value
            Additional_Structure
            TotalBuilding_Sum_Insured
            GeneralContentSI 
            ValuableContentSI
            TotalContentSI
            Total_SI
            Type_Of_Cover
        }
    }
  }
`;

export const DOWNLOAD_POLICY_PDF = gql`
  mutation sendPolicyPDF(
    $input: ProposalInput
    $proposalNumber: String
    $policyNumber: String
  ) {
    sendPolicyPDF(
      input: $input
      proposalNumber: $proposalNumber
      policyNumber: $policyNumber
    ) {
      base64Pdf
    }
  }
`;

export const SEND_POLICY_EMAIL_ALERT = gql`
  mutation sendPolicyEmail(
    $input: ProposalInput
    $email: String
    $policyNumber: String
    $proposalNumber: String
    $ccEmailIds: [String]
  ) {
    sendPolicyEmail(
      input: $input
      email: $email
      policyNumber: $policyNumber
      proposalNumber: $proposalNumber
      ccEmailIds: $ccEmailIds
    ) {
      message
    }
  }
`;

export const SEND_POLICY_SMS_ALERT = gql`
  mutation sendPolicySMS(
    $input: ProposalInput
    $mobile: String
    $policyNumber: String
    $proposalNumber: String
    $alternateMobileNos: [String]
    $whatsappNo: String
    $modes: [String]
  ) {
    sendPolicySMS(
      input: $input
      mobile: $mobile
      policyNumber: $policyNumber
      proposalNumber: $proposalNumber
      alternateMobileNos: $alternateMobileNos
      whatsappNo: $whatsappNo
      modes: $modes
    ) {
      message
    }
  }
`;